import { createContext } from "react";
import type { LinkRenderer } from "@softmax/design-system";

export type FeatureNavigation = {
  readonly pathname: string;
  readonly search: string;
  readonly push: (destination: {
    readonly href: string;
    readonly scroll?: boolean | undefined;
  }) => void;
  readonly replace: (destination: {
    readonly href: string;
    readonly scroll?: boolean | undefined;
  }) => void;
  readonly back: () => void;
  readonly refresh: () => void;
};

export type FeatureHost = {
  readonly navigation: FeatureNavigation;
  readonly renderLink: LinkRenderer;
};

export const NavigationContext = createContext<FeatureHost | null>(null);
